import { http } from "helpers/Http";
import {
  IAddItemShoppingBagParams,
  ICreateNewShoppingBagParams,
  IManyShoppingBagResponse, IShoppingBagData,
  IShoppingBagRemoveItemParams,
  ISingleShoppingBagResponse,
  IUpdateItemShoppingBag,
} from "types/ShoppingBag";
import logger from "components/Logger";

const path = "services/api/requests/ShoppingBag/index.ts";

function stripInvalidUUIDCharacters(input: string) {
  // Define a regular expression to match valid UUID characters (hex digits and hyphens)
  const validUUIDChars = /[0-9a-fA-F-]/g;

  // Use the regular expression to filter out invalid characters
  return input.match(validUUIDChars)?.join('') || '';
}

/**
 * use only 'table' OR 'customOriginQrCode', OR none. NEVER both.
 * @param place_id
 * @param user_id
 * @param table
 * @param customOriginQrCode
 * @param whatsappIdentifier
 */
export async function fetchAPIShoppingBag(place_id:number,
                                          user_id: number,
                                          table: number | undefined,
                                          customOriginQrCode: number | undefined,
                                          whatsappIdentifier: string | undefined): Promise<ISingleShoppingBagResponse> {

  let tableOrCustomOrigin = "";
  if (table && !customOriginQrCode) tableOrCustomOrigin = `&table_number=${table}`;
  if (!table && customOriginQrCode) tableOrCustomOrigin = `&custom_origin_qr_code=${customOriginQrCode}`;

  if(whatsappIdentifier !== undefined){
    whatsappIdentifier = stripInvalidUUIDCharacters(whatsappIdentifier);
  }
  const wani = whatsappIdentifier !== undefined ? `&wani=${whatsappIdentifier}` : '';

  const url = `usersorders/shoppingbag?place_id=${place_id}&user_id=${user_id}${tableOrCustomOrigin}${wani}`;
  const promise = http.get(url).then((response) => response.data);

  logger.log("*************************************************");
  logger.log(`* FILE: ${path} | METHOD: fetchAPIShoppingBag`);
  logger.log(`* table: ${table}`);
  logger.log(`* customOriginQrCode: ${customOriginQrCode}`);
  logger.log(`* is AXIOSing to ${url}`);
  logger.log(`* PROMISE:`, promise);
  logger.log("*************************************************");

  return promise;
}

export async function postAlterShoppingBagTableNumber(params: {
  user_order_id: number, shoppingBag: IShoppingBagData
}): Promise<IManyShoppingBagResponse> {
  const url = `usersorders/update/${params.user_order_id}`;
  const promise = http
    .post(url, params.shoppingBag)
    .then((response) => response.data);

  logger.log("*************************************************");
  logger.log(`* FILE: ${path} | METHOD: postAlterShoppingBagTableNumber`);
  logger.log(`* is AXIOSing to ${url}`);
  logger.log(`* PROMISE:`, promise);
  logger.log("*************************************************");


  return promise;
}

export async function postCreateNewShoppingBag(params: ICreateNewShoppingBagParams): Promise<ISingleShoppingBagResponse> {
  const url = `usersorders/new`;
  return http
    .post(url, {
      user_id: params.user_id,
      place_id: params.place_id,
      table_number: params.table_number,
      custom_origin_qr_code: params.custom_origin_qr_code,
    })
    .then((response) => response.data);
}

export async function postAddItemShoppingBag(params: IAddItemShoppingBagParams): Promise<ISingleShoppingBagResponse> {
  const url = `usersorders/items/new`;
  const query = http
    .post(url, {
      compositionGroups: params.compositionGroupItemList.length ? params.compositionGroups : [],
      flavour_control: params.flavour_control,
      hasComposition: params.compositionGroupItemList.length ? true : false,
      observations: params.observations,
      product_id: params.product_id,
      quantity: params.quantity,
      total_price: params.total_value && params.total_value > 0 ? params.total_value : params.total_price,
      unit_price: params.unit_price,
      user_order_id: params.user_order_id,
    })
    .then((response) => response.data);

  logger.log('******************************************')
  logger.log('* postAddItemShoppingBag')
  logger.log(`* FILE: ${path}`)
  logger.log(`* params:`, params)
  logger.log(`* url:`, url)
  logger.log(`* query:`, query)
  logger.log('******************************************')

  return query
}

export async function postRemoveItemShoppingBag(params: IShoppingBagRemoveItemParams): Promise<ISingleShoppingBagResponse> {
  const url = `usersorders/?order_id=${params.order_id}&item_id=${params.item_id}`;
  const response = http.delete(url).then((response) => response.data);

  logger.log("*************************************************");
  logger.log(`* FILE: ${path} | METHOD: postRemoveItemShoppingBag`);
  logger.log(`* is AXIOSing to ${url}`);
  logger.log('* PROMISE:', response);
  logger.log("*************************************************");

  return response;
}

export async function postUpdateItemShoppingBag({params, body}: IUpdateItemShoppingBag): Promise<ISingleShoppingBagResponse> {
  const url = `usersorders/update/${params.orderId}/item/${params.itemId}`;
  return http.post(url, body).then((response) => response.data);
}
